import type { MessageBannerVariant } from '../MessageBanner'
import { MessageBanner } from '../MessageBanner'

type BlockedBannerProps = {
  message: string
  variant?: MessageBannerVariant
}

export const BlockedBanner = (props: BlockedBannerProps) => {
  return <MessageBanner variant={props.variant}>{props.message}&nbsp;</MessageBanner>
}
